import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ProfileService } from 'src/app/_services/profile.service';
import { WidgetService } from 'src/app/_services/review-services/widget.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-monitoring-incremental-delta',
  templateUrl: './monitoring-incremental-delta.component.html',
  styleUrls: ['./monitoring-incremental-delta.component.css']
})
export class MonitoringIncrementalDeltaComponent implements OnInit, OnChanges {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '290px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    defaultParagraphSeparator: '',
    sanitize: true,
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo',
        'fontSize',
        'fontName',
        'subscript',
        'superscript',
        'htmlCode',
        'insertHorizontalRule',
        'clearFormatting'
      ]
    ]
  };

  @Input() selectedReviewId: number;
  @Input() chosenUser?: string;
  @Input() isEdit: boolean = false;
  @Input() isVisible: boolean = false;
  userLogged: any;
  userRole: string;

  teamMonitoringVelocities: any;
  clientMonitoringVelocities: any;
  velocityTeam: number = 0;
  velocityClient: number = 0;
  selectedTab: 'Team' | 'Cliente';
  isEditSummary: boolean = false;
  isPanelOpen = false;
  summary: string = '';
  monitorignData: any;
  isLoading: boolean = true;

  constructor(
    private readonly widgetService: WidgetService,
    private readonly profileService: ProfileService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.profileService.getUserRoleAsync().then(user => {
      this.userLogged = user;
      this.userRole = this.userLogged.roles[0].name;
    });

    setTimeout((): void => {
      if (!this.chosenUser) this.getMonitoringData();
      this.selectedTab = 'Team';
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['chosenUser']?.currentValue || this.chosenUser) &&
      changes['selectedReviewId']?.currentValue
    ) {
      this.getMonitoringData();
    }
  }

  getMonitoringData() {
    const data = {
      chosen_user: this.chosenUser || this.userLogged,
      start_date: '2024-05-09',
      end_date: '2025-03-06',
      selectedReviewId: this.selectedReviewId
    };
    this.isLoading = true;

    this.widgetService
      .getMonitoringVelocityReview(data)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.isLoading = false;
            this.cdr.detectChanges();
          }, 0);
        })
      )
      .subscribe({
        next: response => {
          this.monitorignData = response;
          this.velocityTeam = response.velocity_team;
          this.velocityClient = response.velocity_client;
          this.teamMonitoringVelocities = response.teamMonitoringVelocities;
          this.clientMonitoringVelocities = response.clientMonitoringVelocities;
          this.summary = response.summary || '';
        },
        error: error => {
          console.error('Error loading monitoring data:', error);
        }
      });
  }

  onTabChange(tab: 'Team' | 'Cliente'): void {
    this.selectedTab = tab;
  }

  editSummary(event: Event) {
    event.stopPropagation();
    this.isEditSummary = true;
    if (!this.isPanelOpen) this.isPanelOpen = true;
  }

  saveSummary(event: Event) {
    event.stopPropagation();

    const data = {
      chosen_user: this.chosenUser,
      selectedReviewId: this.selectedReviewId,
      comment: this.summary
    };

    this.widgetService
      .storeMonitoringVelocityReviewComment(data)
      .subscribe(data => {});

    this.isEditSummary = false;
  }
}
